module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"try":"Try it here"},"fi":{"try":"Kokeile täällä"}}')
  delete Component.options._Ctor
}
